module.exports = __webpack_public_path__ + "static/img/2004.ae021c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2004.png
// module id = 295
// module chunks = 0